/**
 * Format links within text by wrapping URLs with anchor tags.
 *
 * @param {string} text - The text containing URLs to format.
 * @returns {Array} - An array of elements with URLs formatted as anchor tags.
 */
const formatLinks = (text) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.split(urlRegex).map((part, index) => {
    if (index % 2 === 1) {
      return (
        <a key={`link-${index}`} target="_blank" href={part} rel="noreferrer">
          {part}
        </a>
      );
    } else {
      return part;
    }
  });
};

/**
 * Format bold text within elements by wrapping text between '*' characters with <strong> tags.
 *
 * @param {Array} elements - An array of elements to format, where text elements are strings.
 * @returns {Array} - An array of elements with bold text formatted using <strong> tags.
 */
const formatBold = (elements) => {
  const boldRegex = /\*(.*?)\*/g;

  return elements
    .map((element, index) => {
      if (typeof element === 'string') {
        return element.split(boldRegex).map((part, subIndex) => {
          if (subIndex % 2 === 1) {
            return <strong key={`bold-${index}-${subIndex}`}>{part}</strong>;
          } else {
            return part;
          }
        });
      } else {
        return element;
      }
    })
    .flat();
};

/**
 * Format the given text by formatting links and bold elements.
 *
 * @param {string} text - The text to be formatted.
 * @returns {Array} - The fully formatted text with links and bold elements.
 */
export const formatText = (text) => {
  const linkFormattedText = formatLinks(text);
  const fullyFormattedText = formatBold(linkFormattedText);

  return fullyFormattedText;
};
